import styled from 'styled-components';

import { Pencil } from '../../../assets/icons/Pencil';
import { Figures } from '../../../assets/icons/Figures';
import { Text } from '../../../assets/icons/Text';
import { Eraser } from '../../../assets/icons/Eraser';
import { Circle } from '../../../assets/icons/Circle';
import { Square } from '../../../assets/icons/Square';
import { CloseIcon } from '../../../assets/icons/CloseIcon';
import { Selection } from '../../../assets/icons/Selection';

import { ContainerInputProps } from './types';

export const Container = styled.div`
  width: 100%;
  .canvas {
    height: 100%;
    height: 75rem;
  }
  .lower-canvas {
    border: 0.1rem solid ${({ theme }) => theme.colors.black};
    border-radius: 0.5rem;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    .canvas {
      height: 53rem;
    }
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    .canvas {
      height: 36rem;
    }
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    .canvas {
      height: 60rem;
    }
  }
`;

export const ContainerCanvas = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xl};

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const SubContainerCanvas = styled.div`
  width: calc(100% - 8rem);
  background-color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: end;
  margin-top: ${({ theme }) => theme.spacing.xl};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    margin-top: ${({ theme }) => theme.spacing.m};
    justify-content: space-between;
  }
`;

export const ContainerTab = styled.div`
  align-self: start;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  border-radius: 0.5rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: row;
    align-self: end;
  }
`;

export const InputContainer = styled.div<ContainerInputProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5.8rem;
  width: 3.8rem;
  cursor: pointer;
  &:not(:last-child) {
    border-bottom: 0.06rem solid ${({ theme }) => theme.colors.greyLight};
  }
  ${(props) =>
    props.isSelected &&
    `
      background-color: ${props.theme.colors.black};
    `}

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    height: 3.8rem;
    width: 5.8rem;
    &:not(:last-child) {
      border-bottom: none;
      border-right: 0.06rem solid ${({ theme }) => theme.colors.greyLight};
    }
  }
`;

export const Input = styled.input`
  opacity: 0;
  height: 0;
  width: 0;
`;

export const PencilIcon = styled(Pencil)`
  fill: ${({ theme }) => theme.colors.black};
  input[type='radio']:checked + & {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const FiguresIcon = styled(Figures)`
  fill: ${({ theme }) => theme.colors.white};
  stroke: ${({ theme }) => theme.colors.black};
  input[type='radio']:checked + & {
    stroke: ${({ theme }) => theme.colors.white};
    fill: ${({ theme }) => theme.colors.black};
  }
`;

export const TextIcon = styled(Text)`
  fill: ${({ theme }) => theme.colors.black};
  input[type='radio']:checked + & {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

export const EraserIcon = styled(Eraser)`
  stroke: ${({ theme }) => theme.colors.black};
  .right {
    fill: ${({ theme }) => theme.colors.black};
  }
  .left {
    fill: ${({ theme }) => theme.colors.white};
  }
  input[type='radio']:checked + & {
    stroke: ${({ theme }) => theme.colors.white};
    .right {
      fill: ${({ theme }) => theme.colors.white};
    }
    .left {
      fill: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const FiguresContainer = styled.div`
  position: absolute;
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  border-radius: 0.5rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const InputFigureContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3.5rem;
  width: 4.5rem;
  &:not(:last-child) {
    border-right: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.black};
    .icon {
      fill: ${({ theme }) => theme.colors.black};
      stroke: ${({ theme }) => theme.colors.white};
    }
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    height: 4.5rem;
    width: 3.5rem;
    &:not(:last-child) {
      border-right: none;
      border-bottom: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
    }
  }
`;

export const CircleIcon = styled(Circle)`
  fill: ${({ theme }) => theme.colors.white};
  stroke: ${({ theme }) => theme.colors.black};
`;
export const SquareIcon = styled(Square)`
  fill: ${({ theme }) => theme.colors.white};
  stroke: ${({ theme }) => theme.colors.black};
`;

export const ClearIcon = styled(CloseIcon)`
  path {
    fill: ${({ theme }) => theme.colors.black};
  }
`;

export const SelectionIcon = styled(Selection)`
  stroke: ${({ theme }) => theme.colors.black};
`;
